import { CustomOrder } from "./CustomOrder";
import { useCustomOrder } from "./hooks";

export function CustomOrderContainer() {
  const props = useCustomOrder();

  return <CustomOrder {...props} />;
}
